import { memo, useState } from 'react';
import { useDebounceFn } from '@/sub-luca-plugin/utils';
import { navigateExample } from '@/sub-luca-plugin/utils/class-example';
import { message, Checkbox } from '@/sub-luca-plugin/compatible-components';
import { IEquityInitInfo } from '@/sub-luca-plugin/types';
import { handleOrderPay } from './helper';
import './index.scss';

interface IProps {
    ininInfo?: IEquityInitInfo;
    productId?: number;
    productAmount?: number;
    onBuySuccess?: () => void;
}

const PlaceOrder = ({ ininInfo, productId = 0, productAmount = 0, onBuySuccess }: IProps) => {
    const [isChecked, setChecked] = useState(false);
    const { run: handlePayMoney } = useDebounceFn(
        async () => {
            if (!isChecked) {
                return message.warning('请同意用户权益服务协议');
            }
            try {
                const info = await handleOrderPay(productId, ininInfo);
                message.success(info);
                setChecked(false);
                onBuySuccess?.();
            } catch (error) {
                message.warning(error as string);
            }
        },
        { wait: 500 }
    );

    const linkToPrivate = () => {
        navigateExample.linkTo('webview', { url: 'https://gd-file.gaodun.com/luca_private/service-agreement.html' });
    };

    return (
        <div className="place-order">
            <div className="place-order__agreement">
                <Checkbox className="place-order__agreement-checkbox" checked={isChecked} onClick={() => setChecked(!isChecked)} />
                <span>支付及同意</span>
                <span className="place-order__agreement-link" onClick={linkToPrivate}>
                    《用户权益服务协议》
                </span>
            </div>
            <div className="place-order__btn" onClick={handlePayMoney}>
                确认协议并支付 ¥{productAmount}
            </div>
        </div>
    );
};

export default memo(PlaceOrder);
